module.exports = __webpack_public_path__ + "img/weapon_s_2.png";